"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageCache = void 0;
var LocalStorageCache = (function () {
    function LocalStorageCache(cacheKey) {
        this.expireTime = 1800000;
        this.cacheKey = cacheKey;
        this.registryName = cacheKey + "-registry";
    }
    LocalStorageCache.prototype.getRegistry = function () {
        return JSON.parse(localStorage.getItem(this.registryName)) || {};
    };
    LocalStorageCache.prototype.setRegistry = function (registry) {
        localStorage.setItem(this.registryName, JSON.stringify(registry));
    };
    LocalStorageCache.prototype.register = function (key) {
        this.clean();
        var registry = this.getRegistry();
        var timestamp = +new Date();
        registry[this.formatKey(key)] = timestamp;
        this.setRegistry(registry);
        return timestamp;
    };
    LocalStorageCache.prototype.clean = function (timestamp) {
        if (timestamp === void 0) { timestamp = -1; }
        var now = +new Date();
        var registry = this.getRegistry();
        for (var key in registry) {
            if (now - registry[key] > this.expireTime || timestamp > registry[key]) {
                localStorage.removeItem(key);
                delete registry[key];
            }
        }
        this.setRegistry(registry);
    };
    LocalStorageCache.prototype.clear = function () {
        var registry = this.getRegistry();
        for (var key in registry) {
            if (registry.hasOwnProperty(key)) {
                localStorage.removeItem(key);
            }
        }
        this.setRegistry({});
    };
    LocalStorageCache.prototype.formatKey = function (key) {
        return this.cacheKey + "-" + key;
    };
    LocalStorageCache.prototype.get = function (key) {
        this.clean();
        return JSON.parse(localStorage.getItem(this.formatKey(key)));
    };
    LocalStorageCache.prototype.set = function (key, value) {
        this.register(key);
        localStorage.setItem(this.formatKey(key), JSON.stringify(value));
    };
    LocalStorageCache.enabled = !!localStorage;
    return LocalStorageCache;
}());
exports.LocalStorageCache = LocalStorageCache;
